import axios from "axios";

import { cookieGETToken } from "cookie/general";

/**
 * Attaches the admin token to every axios request.
 *
 * The reporting screens and the till use axios directly rather than going
 * through api/general, so an interceptor registered once covers them all --
 * and, more importantly, covers anything added later. Doing it per call is how
 * you end up with one report that 401s because somebody copied a different
 * function as their template.
 *
 * Harmless for the till: it has no token, nothing is attached, and its routes
 * do not ask for one.
 *
 * Imported for its side effect from src/index.js, so it is registered before
 * any component can fire a request.
 */
axios.interceptors.request.use((config) => {
  const token = cookieGETToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axios;
